module.exports = __webpack_public_path__ + "media/four-and-a-half-stars.ef1f0bfb.svg";